"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roadAddress = void 0;
exports.roadAddress = function (axios) {
    return {
        getRoadAddressesAddress: function (getRoadAddressesEnAddressRequest) {
            return axios.get("/road-addresses/" + getRoadAddressesEnAddressRequest.pathParams.address, getRoadAddressesEnAddressRequest);
        },
        getRoadAddressesEnAddress: function (getRoadAddressesEnAddressRequest) {
            return axios.get("/road-addresses/en/" + getRoadAddressesEnAddressRequest.pathParams.address, getRoadAddressesEnAddressRequest);
        }
    };
};
